import {
    DEALER_DETAILS,
    BASKET_ID,
    ADDRESS_SEARCH,
    APPOINTMENT_DETAILS,
    VEHICLE_INFOS,
    VEHICLE_EDIT,
    FROM_LINK,
    SELECTED_MILEAGE_STEP,
    OPERATIONS,
    SELECTED_FORFAITS,
    OPERATIONS_SELECTED,
    SELECTED_MANDATORY_ADDITIONAL_FORFAITS,
    //COMMENT_SERVICES,
    PERSONAL_INFOS,
    SELECTED_PREMIUM_SERVICES,
    PREMIUM_SERVICES,
    //EDITMODE,
    //DIALOG_CONFIRMATION_CHANGE_STEP,
    ATTACHMENTID,
    FILES,
    //DATELIMIT,
    //SELECTED_LAT,
    //SELECTED_LONG,
    //FILTER_DEALERS_BY,
    //FILTER_BY_CHOICE,
    //DEALERS_FILTRED,
    //IDRDVLEADS
} from '../actions/types'

const defaultState =

{
    // navigationStep: 1,
    dealer: {
        ListeIdSP: [],
        SelfReception: false,
        adress: "",
        city: "",
        geoID: "",
        iD: 0,
        name: "",
        position: {
            lat: 48.8400307,
            lng: 2.391748
        },
        rrid: "",
        zip: ""
    },
    addressSearch: {
        address: '',
        lat: Number(window.siteConfig.defaultCountryGeo.lat),
        lng: Number(window.siteConfig.defaultCountryGeo.lng)
        // lat: mapLocation.lat || Number(window.siteConfig.defaultCountryGeo.lat),
        // lng: mapLocation.lng || Number(window.siteConfig.defaultCountryGeo.lng)
    },
    basketId: 0,
    appointment: {},
    isFromLink: false,
    vehicleInfo: {},
    editVehicle: false,
    selectedMileageSteps: {},
    operations: [],
    selectedForfaits: [],
    selectedMandatoryAdditionalForfaits: [],
    selectedOperations: [],
    selectedPremiumServices: [],
    //commentServices: '',
    personalInfos: {},
    listPremiumServices: [],
    //visibaleDialogId: '',
    //isEditMode: false,
    customerAttachmentId: "",
    UploadFiles: [],
    //dateLimitModif: "",
    //selectedLat: 1,
    //filterDealersBy: "",
    //filterByChoice: [],
    //dealersFiltred: [],
    //idRdvLeads: 0
}



export default (state = defaultState, action) => {
    switch (action.type) {
        // case NAVIGATION_STEP:
        case BASKET_ID:
        case DEALER_DETAILS:
        case ADDRESS_SEARCH:
        case APPOINTMENT_DETAILS:
        case FROM_LINK:
        case VEHICLE_INFOS:
        case VEHICLE_EDIT:
        case OPERATIONS:
        case SELECTED_FORFAITS:
        case SELECTED_MILEAGE_STEP:
        case OPERATIONS_SELECTED:
        case SELECTED_MANDATORY_ADDITIONAL_FORFAITS:
        case PERSONAL_INFOS:
        case PREMIUM_SERVICES:
        case SELECTED_PREMIUM_SERVICES:
        //   case COMMENT_SERVICES:

        //   case EDITMODE:
        //   case DIALOG_CONFIRMATION_CHANGE_STEP:
        case ATTACHMENTID:
        case FILES:
            //   case DATELIMIT:
            //   case SELECTED_LAT:
            //   case SELECTED_LONG:
            //   case FILTER_DEALERS_BY:
            //   case FILTER_BY_CHOICE:
            //   case DEALERS_FILTRED:
            //   case IDRDVLEADS:
            return { ...state, ...action }
        default:
            return state
    }
}
